const FormResources = {

    form_data:{
        shift_id:       '',
        time_start:     '',
        time_end:       '',
        number:         '',
        description:    '',
        time:           '',
        length:         0,
        paid:           false,
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift:',
            model_name: 'shift_id',
            ref:        'shift_input',
            ref_alt:    'shift_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'time',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Shift start:',
            model_name: 'time_start',
            ref:        'time_start_input',
            ref_alt:    'time_start_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'time',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Shift end:',
            model_name: 'time_end',
            ref:        'time_end_input',
            ref_alt:    'time_end_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Break #:',
            model_name: 'number',
            ref:        'number_input',
            ref_alt:    'number_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'time',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Break time:',
            model_name: 'time',
            ref:        'time_input',
            ref_alt:    'time_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Length:',
            model_name: 'length',
            ref:        'length_input',
            ref_alt:    'length_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6  ',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Paid:',
            model_name: 'paid',
            ref:        'paid_input',
            ref_alt:    'paid_input_alt',
            required:   false,
        },
    ],

}

export default FormResources;